import React from "react"
import { IntegracaoWhatsappContextProvider } from "./context/IntegracaoWhatsappContextProvider"
import { IntegracaoWhatsapp } from "./IntegracaoWhatsapp"

export function Index() {
    return (
        <IntegracaoWhatsappContextProvider>
            <IntegracaoWhatsapp />
        </IntegracaoWhatsappContextProvider>
    )
}
